module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Black.bdc1fd7.ttf";